import { chain, map } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { applicationLoaded } from '../../actions/application-loaded';
import * as appLifecycleService from '../../services/app-lifecycle-service';

const BACKGROUND_IMG_REGEX = /^url\("(.+)"\)$/;

export class AppLoaded extends Component {
  componentDidMount() {
    this.init();
  }

  componentWilReceiveProps({ key }) {
    if (this.props.key !== key) {
      this.cleanUp();
    }
  }

  componentDidUpdate({ key }) {
    if (this.props.key !== key) {
      this.init();
    }
  }

  componentWillUnmount() {
    this.cleanUp();
  }

  init() {
    this.timeout = setTimeout(() => { // Ensures that masonry is rendered
      appLifecycleService.appLoadedBeforeImages({ logInSdk: true });
      const { selector } = this.props;
      this.pendingImages = selector ?
        [...this.getImages(selector), ...this.getBackgroundImages(selector)] :
        [];
      this.pendingImages.forEach(image => image.addEventListener('load', this.handleImageLoad));
      this.triggerAppLoadedIfNeeded();
    });
  }

  cleanUp() {
    clearTimeout(this.timeout);
    (this.pendingImages || []).forEach(image => image.removeEventListener('load', this.handleImageLoad));
  }

  getImages(selector) {
    return map(
      this.getParent().querySelectorAll(`${selector} img`),
      imageElement => this.createImage(imageElement.src)
    );
  }

  getBackgroundImages(selector) {
    return chain(this.getParent().querySelectorAll(`${selector} [role=img]`))
      .filter(element => BACKGROUND_IMG_REGEX.test(element.style.backgroundImage))
      .map(imageElement => this.createImage(BACKGROUND_IMG_REGEX.exec(imageElement.style.backgroundImage)[1]))
      .value();
  }

  createImage(src) {
    const img = new Image();
    img.src = src;
    return img;
  }

  getParent() {
    const { parent } = this.props;
    return parent ? findDOMNode(parent) : document;
  }

  handleImageLoad = event => {
    const images = this.pendingImages;
    const index = images.indexOf(event.target);
    this.pendingImages = [
      ...images.slice(0, index),
      ...images.slice(index + 1, images.length),
    ];
    this.triggerAppLoadedIfNeeded();
  };

  triggerAppLoadedIfNeeded() {
    if (!this.pendingImages.length) {
      this.props.applicationLoaded();
    }
  }

  render() {
    return null;
  }
}

AppLoaded.propTypes = {
  parent: PropTypes.object,
  selector: PropTypes.string,
  key: PropTypes.any,
  applicationLoaded: PropTypes.func,
};

const mapDispatchToProps = {
  applicationLoaded,
};

export default connect(undefined, mapDispatchToProps)(AppLoaded);



// WEBPACK FOOTER //
// ./app/components/app-loaded/app-loaded.js